/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailReceiptDto
 */
export interface EmailReceiptDto {
    /**
     * 
     * @type {string}
     * @memberof EmailReceiptDto
     */
    mail: string;
}

/**
 * Check if a given object implements the EmailReceiptDto interface.
 */
export function instanceOfEmailReceiptDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mail" in value;

    return isInstance;
}

export function EmailReceiptDtoFromJSON(json: any): EmailReceiptDto {
    return EmailReceiptDtoFromJSONTyped(json, false);
}

export function EmailReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailReceiptDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mail': json['mail'],
    };
}

export function EmailReceiptDtoToJSON(value?: EmailReceiptDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mail': value.mail,
    };
}

